export default "__VITE_ASSET__2bda8b58__"